import Axios from 'axios'
import ElementUI from 'element-ui';
import resetMessage from '@/utils/resetMessage'
// import config from '@/config'

import { getToken,getTokenName, getCallUrl } from '@/utils/auth'
import { loginUrl } from '@/api/api'


Axios.defaults.timeout = 10000 // 响应时间
// 本地设置跨域
Axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'api' : process.env.VUE_APP_BASE_API
Axios.defaults.withCredentials=true;

// 添加一个请求拦截器 
Axios.interceptors.request.use(
    config => {
        config.headers.deviceInfo = 'pc';
        if (getToken()) {
            let tokenName = getTokenName()
            config.headers.common[tokenName] = getToken();
            
        }
        return config
    },
    error => {
        // _.toast('错误的传参', 'fail')
        return Promise.reject(error)
    }
)

// 响应拦截器
Axios.interceptors.response.use(
    function (response) {
        // console.log(response)
        if (response.data.code == "401") {
            resetMessage.info('您的登录已过期，请刷新后重新登录')
            // tryHideFullScreenLoading()
            // token过期，跳转至验证身份的链接
            getCallUrl()
            localStorage.clear()
            return
        } else {
            if(response.data.code != 0) {
            	if(response.data.msg){
            		resetMessage.info(response.data.msg)
            	}
            }
            return response.data
        }
    },
    function (error) {
        return Promise.reject(error)
    }
)

export default Axios